import React from 'react';
type InsurancePartner = {
  name: string;
  logo: string;
  company: string;
  features: string[];
  quoteUrl: string;
};
const insurancePartners: InsurancePartner[] = [{
  name: 'Steadily',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4gqEjAA6ntBs1i1jYM8HUK/Steadily_Logo_Transparent_%281%29.png',
  features: ['Preferred pricing for Mastermind members.', 'Quote and bind policies in minutes.', 'Quick and hassle-free claims for landlords.'],
  quoteUrl: 'https://tractic.steadilypartner.com/'
}, {
  name: 'Obie',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hMXrAiLBnCGKayEbaTby2a/Obie_Logo_%282%29.png',
  features: ['Get a quote in under 5 minutes.', 'Tailored for landlords, not homeowners.', 'Manage multiple properties easily.'],
  quoteUrl: 'https://www.obieinsurance.com/partner/tractic'
}];
export function InsurancePartnersSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-black" data-id="element-41">
      <div className="max-w-7xl mx-auto" data-id="element-42">
        <div className="text-center mb-12" data-id="element-43">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-44">
            Insurance Partners
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto mb-16" data-id="element-45">
            Unlock tailored financing solutions to support your property
            investments. Access competitive rates, flexible loan options, and
            expert guidance.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20" data-id="element-46">
          {insurancePartners.map((partner, index) => <div key={index} className="bg-gray-900 rounded-lg overflow-hidden border border-gray-800 hover:border-[#4a7c59] transition-colors duration-300" data-id="element-47">
              <div className="bg-transparent p-8 flex items-center justify-center h-56" data-id="element-48">
                <img src={partner.logo} alt={`${partner.name} logo`} className={`${partner.name === 'Steadily' ? 'h-40' : 'h-full'} w-auto object-contain`} data-id="element-49" />
              </div>
              <div className="p-6" data-id="element-50">
                <div className="mb-4" data-id="element-51">
                  <p className="text-[#4a7c59] font-semibold" data-id="element-52">{partner.name}</p>
                </div>
                <ul className="space-y-3 mb-6" data-id="element-53">
                  {partner.features.map((feature, idx) => <li key={idx} className="text-gray-300 text-sm flex items-start" data-id="element-54">
                      <span className="text-[#4a7c59] mr-2" data-id="element-55">•</span>
                      {feature}
                    </li>)}
                </ul>
                <a href={partner.quoteUrl} target="_blank" rel="noopener noreferrer" className="inline-block bg-[#4a7c59] hover:bg-[#3d6649] text-white font-bold py-2 px-6 rounded-md text-sm transition-colors duration-200" data-id="element-56">
                  Get Quote Now
                </a>
              </div>
            </div>)}
        </div>
        <div className="text-center mb-12 mt-32" data-id="element-57">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-58">
            Access to Deals!
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto mb-16" data-id="element-59">
            Connect with established real estate investment firms offering
            exclusive opportunities to Mastermind members.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-32" data-id="element-60">
          <div className="bg-gray-900 rounded-lg overflow-hidden border border-gray-800 hover:border-[#4a7c59] transition-colors duration-300" data-id="element-61">
            <div className="bg-transparent p-8 flex items-center justify-center h-56" data-id="element-62">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wx6kaJxV93yN5Rk3LNg5we/SDIRA_Wealth_Logo.jpg" alt="SDIRA Wealth logo" className="h-full w-auto object-contain" data-id="element-63" />
            </div>
            <div className="p-6" data-id="element-64">
              <div className="mb-4" data-id="element-65">
                <p className="text-[#4a7c59] font-semibold" data-id="element-66">SDIRA Wealth</p>
              </div>
              <ul className="space-y-3 mb-6" data-id="element-67">
                <li className="text-gray-300 text-sm flex items-start" data-id="element-68">
                  <span className="text-[#4a7c59] mr-2" data-id="element-69">•</span>
                  Exclusive Build-to-Rent (BTR) deals customized for Mastermind
                  Members.
                </li>
                <li className="text-gray-300 text-sm flex items-start" data-id="element-70">
                  <span className="text-[#4a7c59] mr-2" data-id="element-71">•</span>
                  Diversify your portfolio with strategic turnkey investment
                  opportunities.
                </li>
                <li className="text-gray-300 text-sm flex items-start" data-id="element-72">
                  <span className="text-[#4a7c59] mr-2" data-id="element-73">•</span>
                  Streamlined investment process designed specifically for real
                  estate investors.
                </li>
              </ul>
              <a href="https://forms.gle/ZJQizK8vuKqLphTw5" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#4a7c59] hover:bg-[#3d6649] text-white font-bold py-2 px-6 rounded-md text-sm transition-colors duration-200" data-id="element-74">
                Schedule 1:1 Consultation
              </a>
            </div>
          </div>
          <div className="bg-gray-900 rounded-lg overflow-hidden border border-gray-800 hover:border-[#4a7c59] transition-colors duration-300" data-id="element-75">
            <div className="bg-transparent p-8 flex items-center justify-center h-56" data-id="element-76">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jzhrBeKh35sFaUP825mdS4/chrome_XIdDLR9tnk.png" alt="Alliance Wealth Builders logo" className="h-full w-auto object-contain" data-id="element-77" />
            </div>
            <div className="p-6" data-id="element-78">
              <div className="mb-4" data-id="element-79">
                <p className="text-[#4a7c59] font-semibold" data-id="element-80">
                  Alliance Wealth Builders
                </p>
              </div>
              <ul className="space-y-3 mb-6" data-id="element-81">
                <li className="text-gray-300 text-sm flex items-start" data-id="element-82">
                  <span className="text-[#4a7c59] mr-2" data-id="element-83">•</span>
                  Access turnkey, single-family homes in the growing Birmingham,
                  AL market.
                </li>
                <li className="text-gray-300 text-sm flex items-start" data-id="element-84">
                  <span className="text-[#4a7c59] mr-2" data-id="element-85">•</span>
                  Invest confidently with fully renovated properties ready for
                  immediate occupancy.
                </li>
                <li className="text-gray-300 text-sm flex items-start" data-id="element-86">
                  <span className="text-[#4a7c59] mr-2" data-id="element-87">•</span>
                  Simplified acquisition process tailored for real estate
                  investors aiming for passive income with a solid property
                  management vertical.
                </li>
              </ul>
              <a href="https://forms.gle/RVZhN1AvbeBikvdx7" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#4a7c59] hover:bg-[#3d6649] text-white font-bold py-2 px-6 rounded-md text-sm transition-colors duration-200" data-id="element-88">
                Schedule 1:1 Consultation
              </a>
            </div>
          </div>
        </div>
        <div className="text-center mb-12 mt-32" data-id="element-89">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-90">
            Tax & Accounting
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto mb-16" data-id="element-91">
            Connect with trusted tax and accounting professionals who specialize
            in real estate investment strategies.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-32" data-id="element-92">
          <div className="bg-gray-900 rounded-lg overflow-hidden border border-gray-800 hover:border-[#4a7c59] transition-colors duration-300" data-id="element-93">
            <div className="bg-transparent p-8 flex items-center justify-center h-56" data-id="element-94">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iYUsNoSqpmFdFD7VGKYxrY/PCS_Logo.png" alt="Prime Corporate Services logo" className="h-40 w-auto object-contain" data-id="element-95" />
            </div>
            <div className="p-6" data-id="element-96">
              <ul className="space-y-3 mb-6" data-id="element-97">
                <li className="text-gray-300 text-sm flex items-start" data-id="element-98">
                  <span className="text-[#4a7c59] mr-2" data-id="element-99">•</span>
                  Free 1:1 Consultation for Mastermind Members.
                </li>
                <li className="text-gray-300 text-sm flex items-start" data-id="element-100">
                  <span className="text-[#4a7c59] mr-2" data-id="element-101">•</span>
                  Set up your LLC or S-Corp with expert guidance.
                </li>
                <li className="text-gray-300 text-sm flex items-start" data-id="element-102">
                  <span className="text-[#4a7c59] mr-2" data-id="element-103">•</span>
                  Unlock tax-saving strategies tailored for real estate
                  investors.
                </li>
              </ul>
              <a href="https://www.primecorporateservices.com/tracticio/?utm_medium=tracticio" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#4a7c59] hover:bg-[#3d6649] text-white font-bold py-2 px-6 rounded-md text-sm transition-colors duration-200" data-id="element-104">
                Schedule Consultation
              </a>
            </div>
          </div>
          <div className="bg-gray-900 rounded-lg overflow-hidden border border-gray-800 hover:border-[#4a7c59] transition-colors duration-300" data-id="element-105">
            <div className="bg-transparent p-8 flex items-center justify-center h-56" data-id="element-106">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cVrJNLhna3YMEDCbb18yxW/TrueBooks.png" alt="TrueBooks logo" className="h-full w-auto object-contain" data-id="element-107" />
            </div>
            <div className="p-6" data-id="element-108">
              <ul className="space-y-3 mb-6" data-id="element-109">
                <li className="text-gray-300 text-sm flex items-start" data-id="element-110">
                  <span className="text-[#4a7c59] mr-2" data-id="element-111">•</span>
                  Maximize deductions with real estate-focused tax strategies.
                </li>
                <li className="text-gray-300 text-sm flex items-start" data-id="element-112">
                  <span className="text-[#4a7c59] mr-2" data-id="element-113">•</span>
                  Hassle-free bookkeeping and CPA services for investors.
                </li>
                <li className="text-gray-300 text-sm flex items-start" data-id="element-114">
                  <span className="text-[#4a7c59] mr-2" data-id="element-115">•</span>
                  Stay IRS-compliant with expert tax filing and reporting.
                </li>
              </ul>
              <a href="https://app.truebookscpa.com/tractic?am_id=tractic8" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#4a7c59] hover:bg-[#3d6649] text-white font-bold py-2 px-6 rounded-md text-sm transition-colors duration-200" data-id="element-116">
                Schedule Consultation
              </a>
            </div>
          </div>
        </div>
        <div className="text-center mb-12 mt-32" data-id="element-117">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-118">Financing</h2>
          <p className="text-gray-400 max-w-2xl mx-auto mb-16" data-id="element-119">
            Connect with trusted financing professionals who specialize in real
            estate investment strategies.
          </p>
        </div>
        <div className="flex justify-center mb-32" data-id="element-120">
          <div className="bg-gray-900 rounded-lg overflow-hidden border border-gray-800 hover:border-[#4a7c59] transition-colors duration-300 max-w-2xl w-full" data-id="element-121">
            <div className="bg-transparent p-8 flex items-center justify-center h-56" data-id="element-122">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nsAAmgqEADSvSKsiqMuLMv/Cornerstone_First_Mortgage_Logo.png" alt="Cornerstone First Mortgage logo" className="h-full w-auto object-contain" data-id="element-123" />
            </div>
            <div className="p-6 text-center" data-id="element-124">
              <div className="mb-4" data-id="element-125">
                <p className="text-[#4a7c59] font-semibold text-left" data-id="element-126">
                  Cornerstone Mortgage
                </p>
              </div>
              <ul className="space-y-3 mb-6" data-id="element-127">
                <li className="text-gray-300 text-sm flex items-start" data-id="element-128">
                  <span className="text-[#4a7c59] mr-2 mt-1 flex-shrink-0" data-id="element-129">
                    •
                  </span>
                  <span className="text-left" data-id="element-130">
                    Exclusive Mortgage Solutions tailored specifically for
                    Mastermind members.
                  </span>
                </li>
                <li className="text-gray-300 text-sm flex items-start" data-id="element-131">
                  <span className="text-[#4a7c59] mr-2 mt-1 flex-shrink-0" data-id="element-132">
                    •
                  </span>
                  <span className="text-left" data-id="element-133">
                    Streamlined Application Process with personalized guidance
                    from seasoned mortgage professionals.
                  </span>
                </li>
                <li className="text-gray-300 text-sm flex items-start" data-id="element-134">
                  <span className="text-[#4a7c59] mr-2 mt-1 flex-shrink-0" data-id="element-135">
                    •
                  </span>
                  <span className="text-left" data-id="element-136">
                    Competitive Rates and Flexible Terms designed to boost your
                    passive income from real estate investments.
                  </span>
                </li>
              </ul>
              <div className="flex justify-center" data-id="element-137">
                <a href="https://apply.myhometrac.com/#/milestones?referrerId=rsidley%40cfmtg.com&loanType=MORTGAGE" target="_blank" rel="noopener noreferrer" className="bg-[#4a7c59] hover:bg-[#3d6649] text-white font-bold py-2 px-6 rounded-md text-sm transition-colors duration-200" data-id="element-138">
                  Get Qualified Today!
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}